import moment from "moment";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import {
    GetPadraoCobrancaController,
    ListarFrequenciaVencimentoController,
    ListarIndiceReajusteParcelaController,
    ListarPadraoCobrancaController,
    ListarPlanoIndexadorController,
    ListarTiposDeCustasController,
} from "../../../../Controllers/Geral/LancamentoCustas/LancamentoCustasController";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { IParcelasCustasRequest } from "../../../../Interfaces/Geral/LancamentoCustas/LancamentoCustasInterface";
import OrSpinner from "../../../Utils/OrSpinner";
import LazySelect from "../../Forms/LazySelect";

interface ILancamentoCustasProps {
    empresa: string;
    obra: string;
    venda: string;

    idCaso: number;
    idTipoCaso: number;
}

export function Detalhes(props: ILancamentoCustasProps) {
    const formLancamentoCusta = useFormContext<IParcelasCustasRequest>();
    const { register, formState } = formLancamentoCusta;

    // funções de listagem
    const ListarPlanoIndexador = useCallback(
        () =>
            ListarPlanoIndexadorController(
                props.empresa,
                props.obra,
                props.venda
            ),
        [props.empresa, props.obra, props.venda]
    );

    const { value: lstPadraoCobranca } = useAsyncEffect(
        () => ListarPadraoCobrancaController(props.empresa),
        []
    );

    const { value: getPadraoCobranca, loading: lstPadraoCobrancaLoading } =
        useAsyncEffect(
            () => GetPadraoCobrancaController(props.empresa, props.obra),
            [props.empresa, props.obra]
        );

    return (
        <OrSpinner loading={lstPadraoCobrancaLoading} spinner="capys">
            <h3 className="mt-5">Selecione as informações Referentes:</h3>
            <div className="d-flex flex-wrap justify-content-between align-items-end mt-6">
                <div className="d-flex flex-wrap justify-content-center col-sm-4 col-md-4">
                    <label>Origem</label>
                    <select
                        className={`form-control placeholder-dark-50  ${
                            formState.errors.Origem && "is-invalid"
                        }`}
                        name="Origem"
                        ref={register({
                            required: true,
                        })}
                    >
                        <option></option>
                        <option value="0">0 - Obra</option>
                        <option value="1">1 - Administração</option>
                    </select>
                </div>
                <div className="d-flex flex-wrap justify-content-center col-sm-4 col-md-4">
                    <LazySelect
                        label="Plano Indexador:"
                        className={`form-control placeholder-dark-50  ${
                            formState.errors.PlanoIdx && "is-invalid"
                        }`}
                        name="PlanoIdx"
                        ref={register({
                            required: true,
                        })}
                        controller={ListarPlanoIndexador}
                        getDS={(c) =>
                            `${c.GrupoIdx_pidx} - ${moment(c.Data_pidx).format(
                                "DD/MM/YYYY"
                            )} - ${c.IdxReaj_pidx}`
                        }
                        getKeyValue={(c) => c.GrupoIdx_pidx}
                        //getKeyValue={c=>`${c.GrupoIdx_pidx} - ${moment(c.Data_pidx).format('DD/MM/YYYY')} - ${c.IdxReaj_pidx}`}
                        //useIndexAsValue
                    >
                        <option></option>
                    </LazySelect>
                </div>
                <div className="d-flex flex-wrap justify-content-center col-sm-4 col-md-4">
                    <LazySelect
                        label="Tipo:"
                        className={`form-control placeholder-dark-50  ${
                            formState.errors.Tipo && "is-invalid"
                        }`}
                        name="Tipo"
                        ref={register({
                            required: true,
                        })}
                        controller={ListarTiposDeCustasController}
                        getDS={(c) => `${c.NUM_CTP} - ${c.DESCR_CTP}`}
                        getKeyValue={(c) => c.NUM_CTP}
                    >
                        <option></option>
                    </LazySelect>
                </div>
                <div className="d-flex flex-wrap justify-content-center col-sm-4 col-md-4 mt-4">
                    <LazySelect
                        label="Frequência:"
                        className={`form-control placeholder-dark-50  ${
                            formState.errors.Frequencia && "is-invalid"
                        }`}
                        name="Frequencia"
                        ref={register({
                            required: true,
                        })}
                        controller={ListarFrequenciaVencimentoController}
                        getDS={(c) => `${c.cod_tv} - ${c.descr_tv}`}
                        getKeyValue={(c) => c.cod_tv}
                    >
                        <option></option>
                    </LazySelect>
                </div>
                <div className="d-flex flex-wrap justify-content-center col-sm-4 col-md-4 mt-4">
                    <LazySelect
                        label="Reajuste:"
                        className={`form-control placeholder-dark-50  ${
                            formState.errors.Reajuste && "is-invalid"
                        }`}
                        name="Reajuste"
                        ref={register({
                            required: true,
                        })}
                        controller={ListarIndiceReajusteParcelaController}
                        getDS={(c) => `${c.Cod_idx} - ${c.Descr_idx}`}
                        getKeyValue={(c) => c.Cod_idx}
                    >
                        <option></option>
                    </LazySelect>
                </div>
                <div className="d-flex flex-wrap justify-content-center col-sm-4 col-md-4 mt-4">
                    <label>Padrão Cobrança</label>
                    {lstPadraoCobranca && (
                        <select
                            className={`form-control placeholder-dark-50  ${
                                formState.errors.PadraoCobranca && "is-invalid"
                            }`}
                            name="PadraoCobranca"
                            defaultValue={
                                getPadraoCobranca?.[0]?.numpcbobra_obr
                            }
                            ref={register({
                                required: true,
                            })}
                        >
                            <option></option>
                            {lstPadraoCobranca?.map((padraoCobranca) => (
                                <option value={padraoCobranca.Num_pcb}>
                                    {padraoCobranca.Descr_pcb}
                                </option>
                            ))}
                        </select>
                    )}
                </div>
            </div>
        </OrSpinner>
    );
}
